import React, { useEffect, useRef, useState } from "react";

const ContactoEmergencia = ({value, disabled, onChange}) => {
    const nombreRef = useRef(null);
    const telefonoRef = useRef(null);
    const relacionRef = useRef(null);

    const [editando, setEditando] = useState({
        nombre: false,
        telefono: false,
        relacion: false,
    });

    const toggleEdit = (prop) => setEditando({
        nombre: false,
        telefono: false,
        relacion: false,
        [prop]: !editando[prop],
    });

    useEffect(() => {
        if (disabled) {
            setEditando({
                nombre: false,
                telefono: false,
                relacion: false,
            });
        }
    }, [disabled]);

    useEffect(() => {
        if (editando.nombre && nombreRef.current) {
            nombreRef.current.focus();
        }

        if (editando.telefono && telefonoRef.current) {
            telefonoRef.current.focus();
        }

        if (editando.relacion && relacionRef.current) {
            relacionRef.current.focus();
        }
    }, [editando]);

    return <>
        <div className="row my-1">
            <div className="col">
                {editando.nombre
                    ? <input ref={nombreRef} className="form-control" type="text" value={value.nombre ?? ''} onChange={(e) => onChange({...value, nombre: e.target.value})} onBlur={() => toggleEdit('nombre')} />
                    : <span onClick={() => toggleEdit('nombre')}><i className="fas fa-user"></i> {value.nombre}</span>
                }
            </div>

            <div className="col">
                {editando.relacion
                    ? <input ref={relacionRef} className="form-control" type="text" value={value.relacion ?? ''} onChange={(e) => onChange({...value, relacion: e.target.value})} onBlur={() => toggleEdit('relacion')} />
                    : <span onClick={() => toggleEdit('relacion')}><i className="fas fa-project-diagram"></i> {value.relacion}</span>
                }
            </div>

            <div className="col">
                {editando.telefono
                    ? <input ref={telefonoRef} className="form-control" type="phone" value={value.telefono ?? ''} onChange={(e) => onChange({...value, telefono: e.target.value})} onBlur={() => toggleEdit('telefono')} />
                    : <span onClick={() => toggleEdit('telefono')}><i className="fas fa-phone-alt"></i> {value.telefono}</span>
                }
            </div>
        </div>
    </>;
};

export default ContactoEmergencia;